import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel", "title", "tiles"]
  static values = { basePath: String }

  connect() {
    this._boundKeyup = this._onKeyup.bind(this)
    document.addEventListener("keyup", this._boundKeyup)
    this._loadPagesData()
  }

  disconnect() {
    document.removeEventListener("keyup", this._boundKeyup)
  }

  open(event) {
    const chip = event.currentTarget
    const wsId = chip.dataset.workspaceId
    const wsName = chip.dataset.workspaceName

    if (!wsId) return

    this.titleTarget.textContent = wsName
    this._renderTiles(wsId)
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.add("opacity-100")
    this.panelTarget.classList.remove("opacity-0", "scale-95", "pointer-events-none")
    this.panelTarget.classList.add("opacity-100", "scale-100")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.remove("opacity-100")
    this.panelTarget.classList.add("opacity-0", "scale-95", "pointer-events-none")
    this.panelTarget.classList.remove("opacity-100", "scale-100")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  // private

  _onKeyup(event) {
    if (event.key === "Escape") this.close()
  }

  _loadPagesData() {
    const el = document.getElementById("workspace-pages-data")
    if (!el) { console.warn("[page-picker] #workspace-pages-data not found"); this._pagesData = {}; return }
    try {
      this._pagesData = JSON.parse(el.textContent)
    } catch (e) {
      console.warn("[page-picker] JSON parse error:", e.message)
      this._pagesData = {}
    }
  }

  _renderTiles(wsId) {
    const pages = this._pagesData[wsId] || []
    const base = this.basePathValue || "/p220/workspace"

    this.tilesTarget.innerHTML = pages.map(page => {
      const href = `${base}/${wsId}/pages/${page.id}`
      const iconHtml = page.icon || this._initialsBadge(page.name)
      return `
        <a href="${href}" data-turbo-prefetch="true"
           class="flex flex-col items-center justify-center gap-2.5 w-24 h-24 rounded-2xl
                  bg-white/10 hover:bg-white/20 backdrop-blur-xl border border-white/15
                  transition-all duration-200 hover:scale-105
                  focus:outline-none focus:ring-2 focus:ring-white/30">
          <span class="text-white text-2xl leading-none">${iconHtml}</span>
          <span class="text-xs text-white/80 text-center leading-tight line-clamp-2 px-2">${this._esc(page.name)}</span>
        </a>`
    }).join("")
  }

  _initialsBadge(name) {
    const initials = this._initials(name)
    return `<span class="inline-flex items-center justify-center w-10 h-10 rounded-xl
                         bg-white/15 border border-white/20 text-sm font-semibold text-white">${initials}</span>`
  }

  _initials(name) {
    const words = (name || "").trim().split(/\s+/)
    if (words.length === 0 || !words[0]) return "—"
    return words.length === 1
      ? words[0].substring(0, 2).toUpperCase()
      : (words[0][0] + words[1][0]).toUpperCase()
  }

  _esc(str) {
    const d = document.createElement("div")
    d.textContent = str || ""
    return d.innerHTML
  }
}
